export default "__VITE_ASSET__065f75a7__"